<template>
    <section class="termination-periods" aria-label="Что произойдёт с трудовыми периодами">
        <h6>Даты прекращения трудовых периодов</h6>
        <p class="small text-muted">Для каждого периода можно выбрать дату увольнения, указать другую дату или сохранить нынешнее окончание. Это доступно для любой формы найма.</p>
        <p v-if="!periods.length" class="text-muted">Трудовых периодов нет.</p>
        <div v-for="period in periods" :key="period.id" class="termination-periods__row">
            <b>{{ employer(period) }}</b>
            <small>{{ describe(period) }}</small>
            <b-form-select :aria-label="'Прекращение периода: ' + employer(period) + ', с ' + formatDate(period.started_on)"
                :value="choice(period).mode" :disabled="disabled || !canManage"
                @change="change(period, {mode: $event})">
                <option value="dismissal">Датой увольнения — {{ formatDate(date) }}</option>
                <option value="date">Другая дата — указать вручную</option>
                <option value="keep">Не менять окончание</option>
            </b-form-select>
            <b-form-group v-if="choice(period).mode === 'date'" class="mt-2 mb-1" label="Дата прекращения" :label-for="'termination-period-' + period.id">
                <b-form-input :id="'termination-period-' + period.id" type="date" :value="choice(period).end_date"
                    :disabled="disabled || !canManage" @input="change(period, {end_date: $event})" />
            </b-form-group>
            <small v-if="choice(period).mode !== 'keep'" class="termination-periods__result">Окончание: {{ formatDate(period.ended_on) }} → {{ formatDate(choice(period).mode === 'dismissal' ? date : choice(period).end_date) }}</small>
            <small v-else>Сохранится: {{ period.ended_on ? formatDate(period.ended_on) : 'без даты окончания' }}.</small>
        </div>
        <p v-if="periods.length && !canManage" class="small text-muted mt-2">Для изменения предложенных дат нужно право редактирования трудовых периодов.</p>
    </section>
</template>
<script>
export default {
    props: {periods: {type:Array,default:()=>[]}, date:String, value:{type:Array,default:()=>[]}, canManage:Boolean, disabled:Boolean},
    methods: {
        choice(p) {return this.value.find(a => Number(a.id) === Number(p.id)) || {mode:'dismissal',end_date:this.date};},
        change(p, change) {this.$emit('input', this.value.map(a => Number(a.id) === Number(p.id) ? {...a, ...change} : a));},
        formatDate(value) {return value ? String(value).split('-').reverse().join('.') : 'не задано';},
        employer(p) {return p.source_organization_name || (p.EmploymentOrganization || p.employment_organization || {}).name || 'Работодатель не указан';},
        describe(p) {return [{staff:'Штат',gph:'ГПХ'}[p.hiring_form] || 'Форма найма не указана',
            p.contract_number ? 'Договор №'+p.contract_number : null,
            this.formatDate(p.started_on)+' — '+this.formatDate(p.ended_on),
            p.source_system === 'manual' ? 'Вручную' : 'Импорт'].filter(Boolean).join(' · ');}
    }
};
</script>
<style scoped>
.termination-periods {border:1px solid #d6e4ed; border-radius:10px; background:#f6fafc; padding:1rem; margin:1rem 0;}
.termination-periods__row {padding:.8rem 0; border-bottom:1px solid #e0e8ef; overflow-wrap:anywhere;}
.termination-periods__row:last-child {border:0;}
.termination-periods__row small {display:block; margin:.4rem 0; color:#526779;}
.termination-periods__row .termination-periods__result {color:#984b23;}
</style>
